<div class="feature-highlight">
  <header class="feature-highlight-header">
    <div class="feature-highlight-icon" aria-hidden="true">
      <ion-icon [name]="icon"></ion-icon>
    </div>
    <h2 class="feature-highlight-title">{{ title }}</h2>
    <p class="feature-highlight-description">{{ description }}</p>
  </header>

  <div *ngIf="videoUrl && safeVideoUrl" class="feature-highlight-media">
    <div class="video-wrapper">
      <iframe
        *ngIf="isYouTube"
        [src]="safeVideoUrl"
        title="Feature video"
        frameborder="0"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
        allowfullscreen
      ></iframe>
      <video *ngIf="!isYouTube" [src]="safeVideoUrl" controls playsinline></video>
    </div>
  </div>

  <footer class="feature-highlight-footer">
    <ion-button expand="block" color="primary" (click)="dismiss()">
      {{ 'featureHighlight.gotIt' | translate }}
    </ion-button>
  </footer>
</div>
